/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Common/EndpointLoadingSpinner" />
import React = require("react");
import { StoreManager } from "DistributedTask/Flux/StoreManager";
import { ActionsCreatorInstanceIds } from "DistributedTaskUI/ServiceEndpoints/Editor/Constants";
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Editor/Resources";
import { EndpointsEditorStore } from "DistributedTaskUI/ServiceEndpoints/Editor/Stores/EndpointsEditorStore";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";

interface IEndpointLoadingSpinnerState {
    loadingSpinnerLabel: string;
}
export class EndpointLoadingSpinner extends VssComponent<{}, IEndpointLoadingSpinnerState> {

    private readonly _endpointEditorStore: EndpointsEditorStore;

    constructor(context: IVssComponentContext) {
        super(context);

        this._endpointEditorStore = StoreManager.GetStore<EndpointsEditorStore>(EndpointsEditorStore, ActionsCreatorInstanceIds.EndpointsEditorStoreInstanceId);
        this._endpointEditorStore.addChangedListener(this._onEndpointStoreChange);

        this.state = {
            loadingSpinnerLabel: ""
        };
    }

    public componentWillUnmount(): void {
        this._endpointEditorStore.removeChangedListener(this._onEndpointStoreChange);
    }

    public render(): React.ReactNode {
        const label = this.state.loadingSpinnerLabel;
        const displayNone = {display: "none"};
        return (<React.Fragment>
            <span style={!label ? displayNone : {}}>
                <Spinner ariaLive="assertive" label={label} className="loading-spinner" size={SpinnerSize.medium} />
            </span>
            <span style={label ? displayNone : {}}>
                {this.props.children}
            </span>
        </React.Fragment>);
    }

    private _onEndpointStoreChange = (): void => {
        const state = this._endpointEditorStore.getState();
        let label: string;

        if (state.setupInProgress) {
            label = Resources.SettingUpSpinnerLabel;
        }
        else if (state.saveInProgress) {
            label = Resources.SavingSpinnerLabel;
        }
        else if (state.verifyInProgress) {
            label = Resources.VerifyingSpinnerLabel;
        }
        else {
            label = "";
        }

        this.setState({
            loadingSpinnerLabel: label
        });
    }
}
